<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
  <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Constants Actions">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button ngbDropdownItem #deleteButton
            [disabled]="(!isAdminRole && !isSuperAdminRole) || constant.tenantConstant.used"
            [ngClass]="{'text-danger': !deleteButton.classList.contains('disabled')}"
            (click)="onRemoveConstant(constant)">
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete organization constant</span></button>
    <button ngbDropdownItem
            [disabled]="(!isAdminRole && !isSuperAdminRole)"
            (click)="onEditConstant(constant)">
      <span class="fa-solid fa-pen"></span>
      <span translate>Edit organization constant</span>
    </button>

  </div>
</div>
